import { Link } from "react-router-dom";
import { categoryList } from "@/mocks/site";
import { eventList } from "@/mocks/events";

export default function CategoryGrid() {
  return (
    <section className="w-full px-5 md:px-10 py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl">
        <span className="inline-flex items-center gap-1.5 text-xs tracking-[0.22em] text-primary-600 font-medium">
          <span className="w-5 h-px bg-primary-400" />
          主题分类
        </span>
        <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          按你关心的方向找事件
        </h2>
        <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
          每一起事件都会被归入不同方向，方便你从熟悉的话题切入，再顺着相关推荐延伸阅读。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {categoryList.map((cat) => {
          const count = eventList.filter((item) => item.category === cat.key).length;
          return (
            <Link
              key={cat.key}
              to={`/events?cat=${cat.key}`}
              className="group flex flex-col p-5 md:p-6 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="flex items-center justify-between">
                <span className="w-11 h-11 flex items-center justify-center rounded-md bg-background-50 border border-background-200 text-primary-600 text-xl">
                  <i className={cat.icon} />
                </span>
                <span className="text-xs text-foreground-500">{count} 起事件</span>
              </div>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950 group-hover:text-primary-700 transition-colors">
                {cat.name}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600 flex-1">{cat.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-primary-700">
                进入分类
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}